import { ButtonLegacy } from '@/components/ui/button-legacy'
import { Flag01Icon } from '@/components/ui/icons'
import { useTranslation } from '@/translations/i18n'

export const MultipleFlagsPopoverTrigger = () => {
	const { t } = useTranslation()

	return (
		<ButtonLegacy
			className='text-blue-700 data-[state=open]:shadow-[0_0_0_4px_var(--color-primary-200)]'
			size='sm'
			type='button'
			variant='secondary'
		>
			<Flag01Icon />
			{t('common:multiple_flags_btn')}
		</ButtonLegacy>
	)
}
